<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="exibirAvisosModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="avisos">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <i class="fas fa-newspaper fa-2x mr-2"></i>
                            Avisos
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <az-empty-state v-if="!avisos.length" msg="Nenhum aviso identificado." />

                        <template v-else>

                            <ul class="nav nav-pills mb-3" id="avisos-tab" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <a class="nav-link active" id="avisos-view-tab" data-toggle="pill" href="#avisos-view" role="tab" aria-controls="avisos-view" aria-selected="true">Leitura</a>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <a class="nav-link" id="avisos-lista-tab" data-toggle="pill" href="#avisos-lista" role="tab" aria-controls="avisos-lista" aria-selected="false">Lista</a>
                                </li>
                            </ul>
                            <div class="tab-content" id="pills-tabContent">
                                <div class="tab-pane fade show active" id="avisos-view" role="tabpanel" aria-labelledby="avisos-view-tab">
                                    <!-- Visualização -->

                                    <div class="card">
                                        <div class="card-header d-flex justify-content-between">
                                            <div>
                                                <a href="#" @click.prevent="ir_para_anterior()" class="card-link" v-if="avisos.length > 1">
                                                    <i class="fas fa-chevron-left"></i> 
                                                </a>
                                            </div>
                                            <div>
                                                <div class="text-center">
                                                    {{ aviso.search }}
                                                </div>
                                                <div class="text-center small text-muted">
                                                    {{ aviso.usuario.st_login }}, 
                                                    {{ $util.getFormatDate(aviso.created_at) }}
                                                    {{ aviso.created_at.substr(11,5) }}
                                                </div>
                                                <div class="text-center" v-if="avisos.length > 1">
                                                    <small v-for="(item, iax) in avisos" :key="iax">
                                                        <a href="#" @click.prevent="selecionado = iax;" class="card-link" :class="iax == selecionado ? 'text-primary' : 'text-black-50'">
                                                            <i class="fas fa-circle mx-1"></i>
                                                        </a>
                                                    </small>
                                                </div>
                                            </div>
                                            <div>
                                                <a href="#" @click.prevent="ir_para_proximo()" class="card-link" v-if="avisos.length > 1">
                                                    <i class="fas fa-chevron-right"></i>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="card-body">
                                            <div>
                                                <span v-html="aviso.st_conteudo" v-if="aviso.fl_html"></span>
                                                <div v-else style="white-space: pre-wrap;">{{ aviso.st_conteudo }}</div>
                                            </div>

                                            <div v-if="aviso.arquivos && aviso.arquivos.length" class="mt-3">
                                                <a :href="arq.arquivo.temporary_url" class="text-white"
                                                    v-for="(arq, iax) in aviso.arquivos" :key="iax" target="_blank">
                                                    <span class="badge badge-primary p-2 mr-2 mb-2">
                                                        <i class="fa fa-paperclip mr-2" aria-hidden="true"></i>
                                                        {{ arq.arquivo.st_titulo }}  
                                                    </span>
                                                </a>
                                            </div>
                                            <pre v-if="false">{{ aviso }}</pre>
                                        </div>
                                        <div class="card-footer">
                                            <az-submit color="primary" @click="registrar_leitura(aviso)" :disabled="aviso.lido">
                                                Lido
                                                <i class="fa fa-check-circle" aria-hidden="true" v-if="aviso.lido"></i>
                                            </az-submit>
                                        </div>
                                    </div>

                                </div>

                                <div class="tab-pane fade" id="avisos-lista" role="tabpanel" aria-labelledby="avisos-lista-tab">

                                    <!-- Lista de Avisos -->
                                    <ul class="list-group mt-3">
                                        <li class="list-group-item" v-for="(item, iax) in avisos" :key="iax">
                                            <div>
                                                <a href="#" @click.prevent="selecionar_aviso(iax)" class="card-link">
                                                    {{ item.search }}
                                                    <i class="fa fa-check-circle ml-2" aria-hidden="true" v-if="item.lido"></i>
                                                </a>
                                            </div>
                                        </li>
                                    </ul>

                                </div>
                            </div>

                        </template>
                        
                        <pre v-if="false">{{ avisos }}</pre>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzSubmit from './util/AzSubmit.vue';
import AzEmptyState from './util/AzEmptyState.vue';
//import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
//import 'swiper/css/swiper.css'

export default {
    data() { 
        return { 
            avisos: null, 
            selecionado: null, 
        };
    },

    components: { 
        AzSubmit, 
        AzEmptyState, 
    },

    computed: { 
        aviso: function () { 
            return _.get(this.avisos, this.selecionado) 
                ? _.get(this.avisos, this.selecionado) 
                : { 
                    search: '?', 
                    st_conteudo: '', 
                };
        }
    },

    methods: { 
        selecionar_aviso(index) { 
            this.selecionado = index;
            $('#avisos-view-tab').tab('show');    
        },

        ir_para_anterior() {
            const index = _.indexOf(_.keys(this.avisos), this.selecionado);

            if ( index > 0 ) { 
                this.selecionado = _.keys(this.avisos)[index-1];
            }
        },

        ir_para_proximo(fechar_se_ultimo = false) { 
            const index = _.indexOf(_.keys(this.avisos), this.selecionado);

            if ( index < this.avisos.length - 1 ) { 
                this.selecionado = _.keys(this.avisos)[index+1];
            } else if ( fechar_se_ultimo ) { 
                $('#exibirAvisosModal').modal('hide');
            }
        },

        registrar_leitura(aviso) { 
            this.$util.atualizar(this, { 
                service: 'avisos',
                func: 'leitura',
                dados: { 
                    id_aviso: aviso.id_aviso,
                },
                callback: () => { 
                    aviso.lido = true;
                }
            });

            this.ir_para_proximo(true); 
        },

        abrir(avisos) { 
            this.avisos = _.cloneDeep(avisos);
            this.selecionado = _.first(_.keys(this.avisos));

            $('#exibirAvisosModal').modal('show');
        },

        carregar(id_aviso = null) { 
            this.avisos = [];
            this.selecionado = null;

            this.$util.load(this, { 
                service: 'avisos',
                parms: { 
                    lista: true,
                    id_aviso: id_aviso,  
                },
                loadTo: res => { 
                    this.avisos = res;
                    this.selecionado = _.first(_.keys(this.avisos));
                }
            });

            this.$nextTick(() => { 
                $('#exibirAvisosModal').modal('show');
            });

        }
    }
}
</script>